// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"Dropdown_dropdown__3vpY5","link":"Dropdown_link__1wzqS"};